import "../css/ExportableField.css";
import CheckBox from "./CheckBox";

export function ExportableField({ data, selected, onSelect, onDelete }) {
  const handleClick = () => {
    if (selected) {
      onDelete(data.id);
    } else {
      onSelect(data.id);
    }
  };

  return (
    <div
      className={`exportable-field-content ${selected ? "selected-field" : ""}`}
      onClick={handleClick}
    >
      <span>{data.text}</span>
      <CheckBox active={selected} onClick={handleClick} />
    </div>
  );
}
